import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { IconLibrary, useServiceJob } from '@product-framework/index';
import { FormattedMessage } from 'react-intl';

function NoDispatchMethodFound({ isRescheduleFlow = false }) {
  const { serviceJob } = useServiceJob();
  return (
    <Box sx={{ my: 2 }}>
      <Alert severity="error">
        <AlertTitle>
          {isRescheduleFlow ? (
            <FormattedMessage
              id="RESCHEDULE_ERROR"
              defaultMessage="Reschedule Error"
            />
          ) : (
            <FormattedMessage
              id="DISPATCH_ERROR"
              defaultMessage="Dispatch Error"
            />
          )}
        </AlertTitle>
        <ul>
          <li>
            {isRescheduleFlow ? (
              <FormattedMessage
                id="ALL_OTHER_AVAILABLE_RESCHEDULE_METHODS_ARE_INACTIVE_FOR_THIS_JOB_SERVICE_JOB_NUMBER"
                defaultMessage="All other available reschedule methods are inactive for this job {serviceJobNumber}"
                values={{
                  serviceJobNumber: serviceJob.serviceJobNumber,
                }}
              />
            ) : (
              <FormattedMessage
                id="ALL_OTHER_AVAILABLE_DISPATCH_METHODS_ARE_INACTIVE_FOR_THIS_JOB_SERVICE_JOB_NUMBER"
                defaultMessage="All other available dispatch methods are inactive for this job {serviceJobNumber}"
                values={{
                  serviceJobNumber: serviceJob.serviceJobNumber,
                }}
              />
            )}
          </li>
        </ul>
      </Alert>
      <Box sx={{ textAlign: 'center', my: 2 }}>
        <Button
          startIcon={<IconLibrary.Back />}
          variant="contained"
          href={`/servicejobs/edit/${serviceJob.id}`}>
          <FormattedMessage
            id="BACK_TO_JOB_SERVICEJOBNUMBER"
            defaultMessage="Back to Job {serviceJobNumber}"
            values={{
              serviceJobNumber: serviceJob.serviceJobNumber,
            }}
          />
        </Button>
      </Box>
    </Box>
  );
}

export default NoDispatchMethodFound;
